import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SettingsIcon from "@mui/icons-material/Settings";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import EditIcon from "@mui/icons-material/Edit";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import CommentIcon from '@mui/icons-material/Comment';
import { ComentariosModal } from "../ComentariosModal";
import GrassIcon from '@mui/icons-material/Grass';
import { CultivoModal } from "../CultivoModal";
import { ChatScreen } from "../../../Whatsapp/ChatScreen";
import FiltroMultiple from "../../../Postventa/Dashboard/Modales/FiltroMultiple";

export const CotizacionesTablaScreen = ({
  cotizaciones,
  puedeEditar,
  puedeEliminar,
  onGeneraPDF,
  onEliminar,
  handleOpenModalFase,
  actualizarLista
}) => {
  const history = useHistory();
  const [openModalComentarios, setOpenModalComentarios] = useState(false);
  const [openModalCultivo, setOpenModalCultivo] = useState(false);
  const [folioSelected, setFolioSelected] = useState("");
  const [cultivoSelected, setCultivoSelected] = useState("");
  const [estadoSelected, setEstadoSelected] = useState(0);


  //Totales
  // const [totalCotizacion, setTotalCotizacion] = useState(0);
  const [totalMensajes, setTotalMensajes] = useState(0);

  const [predictivo, setPredictivo] = useState("");

  // filtros en tabla
  const [options, setOptions] = useState({
    cliente: [],
    cultivo: [],
    fase: [],
    asesor: [],
    sucursal: [],
    linea: [],
    modelo: [],
    esquema: [],
    interes: []
  });
  const [filtros, setFiltros] = useState({
    cliente: [],
    cultivo: [],
    fase: [],
    asesor: [],
    sucursal: [],
    linea: [],
    modelo: [],
    esquema: [],
    interes: []
  });
  const [prioridadFiltros, setPrioridadFiltros] = useState([]);
  const [datosFiltrados, setDatosFiltrados] = useState([]);

  const [filtrosTemp, setFiltrosTemp] = useState({
    cliente: [],
    cultivo: [],
    fase: [],
    asesor: [],
    sucursal: [],
    linea: [],
    modelo: [],
    esquema: [],
    interes: []
  });

  const [mostrarFiltro, setMostrarFiltro] = useState({
    cliente: { open: false },
    cultivo: { open: false },
    fase: { open: false },
    asesor: { open: false },
    sucursal: { open: false },
    linea: { open: false },
    modelo: { open: false },
    esquema: { open: false },
    interes: { open: false }
  });

  const actualizarPrioridad = (filtro) => {
    setPrioridadFiltros((prev) => {
      const index = prev.indexOf(filtro);

      let nuevasPrioridades;

      // nuevo filtro → se agrega
      if (index === -1) {
        nuevasPrioridades = [...prev, filtro];
      }
      // filtro existente → se cortan los posteriores
      else {
        nuevasPrioridades = prev.slice(0, index + 1);
      }

      // 🔥 LIMPIAR filtros que perdieron prioridad
      setFiltrosTemp((prevTemp) => {
        const limpio = { ...prevTemp };

        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) {
            limpio[key] = [];
          }
        });

        return limpio;
      });

      // 🔥 LIMPIAR filtros aplicados también
      setFiltros((prevFiltros) => {
        const limpio = { ...prevFiltros };

        Object.keys(limpio).forEach((key) => {
          if (!nuevasPrioridades.includes(key)) {
            limpio[key] = [];
          }
        });

        return limpio;
      });

      return nuevasPrioridades;
    });
  };

  const aplicarFiltros = (data, filtros, _, filtrosPermitidos = []) => {
    let resultado = [...data];

    filtrosPermitidos.forEach((filtro) => {
      if (filtro === "cliente" && filtros.cliente.length > 0) {
        resultado = resultado.filter((i) => filtros.cliente.includes(i.razon_social));
      }

      if (filtro === "cultivo" && filtros.cultivo.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.cultivo.includes(i.cultivo),
        );
      }

      if (filtro === "fase" && filtros.fase.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.fase.includes(i.fase_cotizacion?.substring(0, 2)),
        );
      }

      if (filtro === "asesor" && filtros.asesor.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.asesor.includes(i.nombre_asesor),
        );
      }

      if (filtro === "sucursal" && filtros.sucursal.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.sucursal.includes(i.sucursal),
        );
      }

      if (filtro === "linea" && filtros.linea.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.linea.includes(i.linea),
        );
      }

      if (filtro === "modelo" && filtros.modelo.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.modelo.includes(i.modelo),
        );
      }

      if (filtro === "esquema" && filtros.esquema.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.esquema.includes(i.esquema),
        );
      }

      if (filtro === "interes" && filtros.interes.length > 0) {
        resultado = resultado.filter((i) =>
          filtros.interes.includes(i.interes),
        );
      }
    });

    return resultado;
  };

  //Actualizacion de datos dependiendo filtros
  useEffect(() => {
    if (!Array.isArray(cotizaciones)) return;

    let data = [...cotizaciones];

    prioridadFiltros.forEach((filtro) => {
      switch (filtro) {
        case "cliente":
          if (filtros.cliente.length > 0) {
            data = data.filter((i) => filtros.cliente.includes(i.razon_social));
          }
          break;

        case "cultivo":
          if (filtros.cultivo.length > 0) {
            data = data.filter((i) =>
              filtros.cultivo.includes(i.cultivo),
            );
          }
          break;

        case "fase":
          if (filtros.fase.length > 0) {
            data = data.filter((i) => filtros.fase.includes(i.fase_cotizacion?.substring(0, 2)));
          }
          break;

        case "asesor":
          if (filtros.asesor.length > 0) {
            data = data.filter((i) =>
              filtros.asesor.includes(
                i.nombre_asesor,
              ),
            );
          }
          break;

        case "sucursal":
          if (filtros.sucursal.length > 0) {
            data = data.filter((i) =>
              filtros.sucursal.includes(
                i.sucursal,
              ),
            );
          }
          break;

        case "linea":
          if (filtros.linea.length > 0) {
            data = data.filter((i) =>
              filtros.linea.includes(
                i.linea,
              ),
            );
          }
          break;

        case "modelo":
          if (filtros.modelo.length > 0) {
            data = data.filter((i) =>
              filtros.modelo.includes(
                i.modelo,
              ),
            );
          }
          break;

        case "esquema":
          if (filtros.esquema.length > 0) {
            data = data.filter((i) =>
              filtros.esquema.includes(
                i.esquema,
              ),
            );
          }
          break;

        case "interes":
          if (filtros.interes.length > 0) {
            data = data.filter((i) =>
              filtros.interes.includes(
                i.interes,
              ),
            );
          }
          break;

        default:
          break;
      }
    });

    setDatosFiltrados(data);
  }, [cotizaciones, filtros, prioridadFiltros]);

  //Esquema de filtrado en tabla
  useEffect(() => {
    if (!Array.isArray(cotizaciones)) return;

    const getBaseData = (filtro) => {
      const index = prioridadFiltros.indexOf(filtro);

      // Si el filtro NO ha sido usado aún → usar data filtrada actual
      if (index === -1) {
        return aplicarFiltros(
          cotizaciones,
          filtros,
          null,
          prioridadFiltros,
        );
      }

      // Si es el primero → data completa
      if (index === 0) {
        return cotizaciones;
      }

      // Solo aplicar filtros con MAYOR prioridad
      const filtrosPrevios = prioridadFiltros.slice(0, index);

      return aplicarFiltros(
        cotizaciones,
        filtros,
        null,
        filtrosPrevios,
      );
    };

    // CLIENTES
    const clienteOptions = [
      ...new Set(getBaseData("cliente").map((i) => i.razon_social)),
    ].map((v) => ({ value: v, label: v }));

    // CULTIVOS
    const cultivoOptions = [
      ...new Set(getBaseData("cultivo").map((i) => i.cultivo)),
    ].map((v) => ({ value: v, label: v }));


    // FASE
    const faseOptions = [
      ...new Set(
        getBaseData("fase")
          .map((i) => i.fase_cotizacion?.substring(0, 2))
          .filter(Boolean) // 🔥 evita undefined/null
      ),
    ].map((v) => ({
      value: v,
      label: getFase(v),
    }));

    // ASESOR
    const asesorOptions = [
      ...new Set(getBaseData("asesor").map((i) => i.nombre_asesor).filter(Boolean)),
    ].map((v) => ({ value: v, label: v }));

    // ASESOR
    const sucursalOptions = [
      ...new Set(getBaseData("sucursal").map((i) => i.sucursal).filter(Boolean)),
    ].map((v) => ({ value: v, label: v }));

    // ASESOR
    const lineaOptions = [
      ...new Set(getBaseData("linea").map((i) => i.linea).filter(Boolean)),
    ].map((v) => ({ value: v, label: v }));

    // ASESOR
    const modeloOptions = [
      ...new Set(getBaseData("modelo").map((i) => i.modelo).filter(Boolean)),
    ].map((v) => ({ value: v, label: v }));

    // ESQUEMA
    const esquemaOptions = [
      ...new Set(getBaseData("esquema").map((i) => i.esquema).filter(Boolean)),
    ].map((v) => ({ value: v, label: v }));

    // INTERES
    const interesOptions = [
      ...new Set(
        getBaseData("interes")
          .map((i) => (i.interes || "").trim().toLowerCase())
      ),
    ].map((v) => ({
      value: v,
      label: v === "-" || v === "" ? "Sin interés" : capitalizePalabras(v),
    }));

    setOptions({
      cliente: clienteOptions,
      cultivo: cultivoOptions,
      fase: faseOptions,
      asesor: asesorOptions,
      sucursal: sucursalOptions,
      linea: lineaOptions,
      modelo: modeloOptions,
      esquema: esquemaOptions,
      interes: interesOptions,
    });
  }, [cotizaciones, filtros, prioridadFiltros]);

  const limpiarFiltros = () => {
    setFiltros({
      cliente: [],
      cultivo: [],
      fase: [],
      asesor: [],
      sucursal: [],
      linea: [],
      modelo: [],
      interes: [],
    });

    setFiltrosTemp({
      cliente: [],
      cultivo: [],
      fase: [],
      asesor: [],
      sucursal: [],
      linea: [],
      modelo: [],
      esquema: [],
      interes: []
    });

    setPrioridadFiltros([]);
    setDatosFiltrados([]);
  };


  const handleOpenModalComentarios = (folio) => {
    setFolioSelected(folio);
    setOpenModalComentarios(true);
  };

  const handleCloseModalComentarios = () => {
    setOpenModalComentarios(false);
    if (actualizarLista) actualizarLista();
  };



  const handleOpenModalCultivo = (folio, cultivo, estado) => {
    setFolioSelected(folio);
    setCultivoSelected(cultivo);
    setEstadoSelected(estado);
    setOpenModalCultivo(true);
  };

  const handleCloseModalCultivo = () => {
    setOpenModalCultivo(false);
    if (actualizarLista) actualizarLista();
    setFolioSelected("");
    setCultivoSelected("");
    setEstadoSelected(0);
  };

  const getFase = (fase) => {
    switch (fase) {
      case "PR":
        return "Promoción";
      case "IN":
        return "Interés";
      case "NE":
        return "Negociación";
      case "CE":
        return "Cerrada";
      case "FM":
        return "Facturar mes";
      case "FS":
        return "Facturar semana";
      case "NC":
        return "No compró";
      case "VP":
        return "Venta perdida";
      case "VN":
        return "Vendido";
    }
  };
  return (
    <div className="cotizaciones">
      {/* <LoaderScreen loader={loader} /> */}
      <div className="cotizaciones-header">
        <div className="cotizaciones-header-title">
          <FormatListNumberedIcon /> Listado de cotizaciones Registradas
        </div>
        <div className="contador-cotizaciones-encontrados">
          Cotizaciones Encontradas: {cotizaciones.length}
        </div>
      </div>
      <div className="cotizaciones-container-ventas scroll">
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th></th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple
                    label="Fase"
                    field="fase"
                    options={options.fase}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                  />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple
                    label="Interes"
                    field="interes"
                    options={options.interes}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                  />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple
                    label="Cultivo"
                    field="cultivo"
                    options={options.cultivo}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                  />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple
                    label="Cliente"
                    field="cliente"
                    options={options.cliente}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                  />
                </div>
                {/* <div>Cliente</div> */}
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple
                    label="Asesor"
                    field="asesor"
                    options={options.asesor}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                  />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple
                    label="Sucursal"
                    field="sucursal"
                    options={options.sucursal}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                  />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple
                    label="Linea"
                    field="linea"
                    options={options.linea}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                  />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple
                    label="Modelo"
                    field="modelo"
                    options={options.modelo}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                  />
                </div>
              </th>
              <th>
                <div className="borde-izq">
                  <FiltroMultiple
                    label="Esquema"
                    field="esquema"
                    options={options.esquema}
                    filtros={filtros}
                    setFiltros={setFiltros}
                    filtrosTemp={filtrosTemp}
                    setFiltrosTemp={setFiltrosTemp}
                    mostrarFiltro={mostrarFiltro}
                    setMostrarFiltro={setMostrarFiltro}
                    actualizarPrioridad={actualizarPrioridad}
                    setPrioridadFiltros={setPrioridadFiltros}
                  />
                </div>
              </th>
              <th>
                <div className="borde-izq">Cantidad</div>
              </th>
              <th>
                <div className="borde-izq">Monto</div>
              </th>
              <th>
                <div className="borde-izq">Fecha cotizacion</div>
              </th>
              <th>
                <div className="borde-izq">Vigencia</div>
              </th>
              <th>
                <div className="borde-izq">Fecha Venta</div>
              </th>
              <th>
                <div className="borde-izq">Entregado</div>
              </th>
              <th>
                <div className="borde-izq">Comentarios</div>
              </th>
              <th style={{ color: "transparent" }}>
                <div className="borde-izq">.</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {(datosFiltrados.length > 0 ? datosFiltrados : cotizaciones).map((co) => (
              <tr>
                {/* <td className="">{co.folio}</td> */}
                <td>
                  <div className="cotizaciones-ventas-options">
                    <div
                      className={`boton-editar-cotizaciones   ${puedeEditar ? "" : "inhabilitado"
                        }`}
                      onClick={() => {
                        if (!puedeEditar) {
                          return;
                        }
                        history.push(
                          "/Ventas/RegistrarCotizacion",
                          {
                            folio: co.folio,
                            puedeEliminar: puedeEliminar
                          }
                        );
                      }}
                    >
                      <EditIcon />
                    </div>
                    <div
                      className="boton-pdf-cotizaciones"
                      onClick={() => onGeneraPDF(co.folio)}
                    >
                      <PictureAsPdfIcon />
                    </div>
                  </div>
                </td>
                <td
                  onClick={() =>
                    handleOpenModalFase(co.folio, co.fase_cotizacion, co.idcliente)
                  }
                >
                  <div className={puedeEditar ? "" : "inhabilitado"}>
                    <SettingsIcon />
                    <span>
                      {co.fase_cotizacion
                        ? getFase(co.fase_cotizacion.substring(0, 2))
                        : "-"}
                    </span>
                  </div>
                </td>
                <td className="">
                  {co.interes ? co.interes : "-"}
                </td>
                <td className="celda-cultivo">
                  <div className="contenido-flex">
                    <div
                      className={`boton-detalle-cotizaciones ${puedeEditar ? "" : "inhabilitado"}`}
                      onClick={() => handleOpenModalCultivo(co.folio, co.cultivo, co.idestado)}
                    >
                      <GrassIcon />
                    </div>
                    <span className="cultivo-texto">
                      {co.cultivo}
                    </span>
                  </div>
                </td>
                <td className="sticky-column">
                  {co.razon_social ? capitalizePalabras(co.razon_social) : "-"}
                </td>
                <td>
                  {co.nombre_asesor
                    ? capitalizePalabras(co.nombre_asesor)
                    : "-"}
                </td>
                <td>{co.sucursal ? capitalizePalabras(co.sucursal) : "-"}</td>
                <td>{co.linea ? co.linea : "-"}</td>
                <td>{co.modelo ? co.modelo : "-"}</td>
                <td className="esquema-celda ">{co.esquema ? capitalizePalabras(co.esquema) : "-"}</td>
                <td>{co.cantidad ? co.cantidad : "-"}</td>
                <td>{co.monto_total ? FormatMoney(co.monto_total) : "-"}</td>
                <td>{co.createdate ? co.createdate : "-"}</td>
                <td>{co.vigencia ? co.vigencia : "-"}</td>
                <td className="fecha-venta-celda ta-center">{co.fecha_venta ? co.fecha_venta : "-"}</td>
                <td className="ta-center">{co.entregado === "N" ? "No" : "Si"}</td>
                <td className="celda-comentario">
                  <div className="contenido-flex">
                    <div
                      className={`boton-detalle-cotizaciones ${puedeEditar ? "" : "inhabilitado"}`}
                      onClick={() => handleOpenModalComentarios(co.folio)}
                    >
                      <CommentIcon />
                    </div>
                    <span className="comentario-texto">
                      {co.comentario}
                    </span>
                  </div>
                </td>
                <td>
                  <div
                    className={`boton-pdf-cotizaciones ${puedeEliminar ? "" : "inhabilitado"
                      }`}
                    onClick={() => onEliminar(co.folio)}
                  >
                    <DeleteIcon />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ComentariosModal
        open={openModalComentarios}
        onClose={handleCloseModalComentarios}
        folio={folioSelected}

      />
      <CultivoModal
        open={openModalCultivo}
        onClose={handleCloseModalCultivo}
        folio={folioSelected}
        cultivo={cultivoSelected}
        idestado={estadoSelected}
      />
    </div>
  );
};
